




























import { defineComponent, ref, watch } from "@vue/composition-api";
import { SwiperOptions } from "swiper";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { Announcement, AnnouncementTypeEnum } from "@scrile/api-provider/dist/api/AnnouncementsProvider";
import { checkRole } from "@scrile/tools/dist/lib/SecurityHelpers";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";
import { ROLES } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import AnnouncementsItem from "./components/AnnouncementsItem";

export default defineComponent({
  name: "Announcements",
  components: { BaseIcon, AnnouncementsItem, Swiper, SwiperSlide },
  setup() {
    const { authUser } = useAuthUser();
    const loading = ref(false);
    const swiperRef = ref();
    const announcements = ref<Announcement[]>([]);
    const closed = ref(false);

    const swiperOptions: SwiperOptions = {
      slidesPerView: "auto",
      allowTouchMove: true,
      spaceBetween: 24,
      grabCursor: true,
      pagination: {
        el: ".announcements__slider-pagination",
        bulletElement: "div",
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active",
        dynamicBullets: true,
        clickable: true,
      },
      navigation: {
        prevEl: ".announcements__slider-prev",
        nextEl: ".announcements__slider-next",
      },
    };

    const onToggleClose = () => {
      closed.value = !closed.value;
    };

    // which announcements a role sees: members and creators their own, the talent agent the creators' ones (it works
    // with creators), admin and manager all of them (they publish and support both sides). Other roles see none.
    const announcementTypes = (): AnnouncementTypeEnum[] => {
      const role = authUser.value?.role ?? "";
      if (checkRole(role, ROLES.MEMBER)) return [AnnouncementTypeEnum.BOTH, AnnouncementTypeEnum.MEMBER];
      if (checkRole(role, [ROLES.CREATOR, ROLES.TALENT_AGENT])) {
        return [AnnouncementTypeEnum.BOTH, AnnouncementTypeEnum.CREATOR];
      }
      if (checkRole(role, [ROLES.ADMIN, ROLES.MANAGER])) {
        return [AnnouncementTypeEnum.BOTH, AnnouncementTypeEnum.MEMBER, AnnouncementTypeEnum.CREATOR];
      }
      return [];
    };

    const getAnnouncements = async (types: AnnouncementTypeEnum[]) => {
      announcements.value = await providers.AnnouncementsProvider.search({
        data: {
          types,
          size: 999,
          sort: "SORT;ID,DESC",
        },
      });
    };

    const getData = async () => {
      try {
        loading.value = true;
        const types = announcementTypes();
        if (!types.length) return;
        await getAnnouncements(types);
      } finally {
        loading.value = false;
      }
    };

    watch(closed, async () => {
      if (!swiperRef.value) return;
      swiperRef.value.swiperInstance.allowTouchMove = !closed.value;
      swiperRef.value.updateSwiper();
    });

    getData();

    return {
      swiperRef,
      announcements,
      swiperOptions,
      loading,
      closed,
      onToggleClose,
    };
  },
});
